/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import * as moment from 'moment/moment';

import {GroupZoneDescriptor, ZoneDescriptor} from '../form-generator.interfaces';

@Component({
  selector: '[gp-form-timeline]',
  templateUrl: 'form-timeline.component.html',
  styleUrls: ['form-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FormTimelineComponent {

  public loaded: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  public descriptor: GroupZoneDescriptor;
  public data: any;
  public readOnly: boolean = false;
  public locale: string;
  public currency: string;
  public isOnBoarding = false;
  public employeeId: number = null;

  private group: UntypedFormGroup;

  @HostBinding('style.display')
  public get position() {
    return 'flex';
  }

  @HostBinding('class.col-xs-12')
  @HostBinding('class.col-md-3')
  public get is3Col() {
    return this.descriptor && this.descriptor.nbCol === 1;
  }

  @HostBinding('class.col-xs-12')
  @HostBinding('class.col-md-6')
  public get is6Col() {
    return this.descriptor && this.descriptor.nbCol === 2;
  }

  @HostBinding('class.col-xs-12')
  @HostBinding('class.col-md-9')
  public get is9Col() {
    return this.descriptor && this.descriptor.nbCol === 3;
  }

  @HostBinding('class.col-xs-12')
  @HostBinding('class.col-md-12')
  public get is12Col() {
    return this.descriptor && this.descriptor.nbCol === 4;
  }

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  public init() {
    this.descriptor.zones = this.descriptor.zones
      .sort((zoneA: ZoneDescriptor, zoneB: ZoneDescriptor) => zoneA.displayorder - zoneB.displayorder);

    this.data = this.data.sort((item1, item2) => {
      return moment(item2.values.EventDate.value).startOf('day')
        .diff(moment(item1.values.EventDate.value).startOf('day'), 'days');
    });

    this.group = this.formBuilder.group({});
    setTimeout(() => {
      this.loaded.emit(this.group);
      this.loaded.complete();
    });


    // .then(groupZonesControlGroup => {
    // this.loaded.emit(this.formBuilder.array([]));
    // this.loaded.complete();
    // });
  }
}
